import React, { useState, useMemo, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Tooltip } from "primereact/tooltip";
import { useTranslation } from 'react-i18next';
import { Tag } from "primereact/tag";
import { Link } from "react-router-dom";
import { Divider } from "primereact/divider";
import { Dialog } from "primereact/dialog";
import FemaleIcon from "assets/icons/FemaleAvatar.png";
import MaleIcon from "assets/icons/MaleAvatar.png";
import NoProfile from "assets/icons/NoProfile.png";
import useApi from "hooks/useApi";

export function PatientCard({
  key,
  number,
  name,
  patient_type,
  gender,
  setVisible,
  setQuery,
}) {
  let profileIcon = NoProfile;
  if (gender === "male") {
    profileIcon = MaleIcon;
  } else if (gender === "female") {
    profileIcon = FemaleIcon;
  }
  return (
          <div
           className="flex align-items-center p-1 mt-5 relative card"
           style={{ gap: '8px', background: 'inherit', borderRadius: '5px' }}
           key={key}
          >
      {patient_type ? (
        <Tag
          value={patient_type}
          style={{ top: '-20px', left: '10px', paddingRight: '6px', paddingLeft: '6px' }}
          className="absolute left-[15px] top-[-10px] px-1.5 !bg-[#edeff0] !text-black !border border-[#edeff0]"
        />
      ) : null}
      <div
        style={{ width: 35, height: 34, borderRadius: 50 }}
        className="flex justify-content-center align-items-center text-center"
      >
        <Link
          to={`/patient/${number}`}
          onClick={() => {
            setQuery("");
            setVisible(false);
          }}
        >
          <img
            src={profileIcon}
            style={{ width: 35, height: 34, borderRadius: 50 }}
          />
        </Link>
      </div>
      <Tooltip target=".investigation-tooltip" />
      <Tooltip target=".journey-start" />
      <div className="flex flex-row gap-2 items-center pr-2.5">
        <div className="flex flex-column justify-content-between w-full gap-1">
          <div className="text-700 text-sm flex justify-content-between">
            <div className="text-sm font-bold flex">
              <Link
                to={`/patient/${number}`}
                className="!text-[var(--primary-color)]"
                onClick={() => {
                  setQuery("");
                  setVisible(false);
                }}
              >
                {name}
              </Link>
            </div>
            <Divider layout="vertical" className="p-0" />
            <div className="text-sm font-bold flex">{number}</div>
            {gender && (
              <>
                <Divider layout="vertical" className="p-0" />
                <div className="text-sm font-bold flex">
                  {gender.toUpperCase()}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
const Search = () => {
  const api = useApi();
  const { t } = useTranslation();
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [noPatientsDialogVisible, setNoPatientsDialogVisible] = useState(false);

  const debouncedSearch = useMemo(
    () =>
      _.debounce(async (searchQuery) => {
        if (searchQuery.trim() === "") {
          setResults([]);
          setVisible(false);
          setNoPatientsDialogVisible(false)
          return;
        }

        try {
          setLoading(true);
          const response = await api.get(
            `events/search_by_personnel_name/${searchQuery}`
          );
          const groupedPatients = _.groupBy(response?.data?.data || [], "mrn");
          const patients = Object.keys(groupedPatients).map(
            (key) => groupedPatients[key][0]
          );
          setResults(patients);
          if (patients.length>0) {
            setVisible(true);
            setNoPatientsDialogVisible(false);
          }else{setNoPatientsDialogVisible(true);
            setVisible(false);
          }
        } catch (error) {
          console.error("Error fetching patients:", error);
          setResults([]);
          setNoPatientsDialogVisible(true);
        } finally {
          setLoading(false);
        }
      }, 1000), // Adjust the delay as needed
    []
  );

  const handleChange = (event) => {
    const newQuery = event.target.value.replace(/^\s+/, '');
    setQuery(newQuery);
    debouncedSearch(newQuery);
  };

  const handleClear = () => {
    setQuery("");
    setResults([]);
    setVisible(false);
    setNoPatientsDialogVisible(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && query.trim() !== "") {
      debouncedSearch(query);
    }
  };

  useEffect(() => {
    const inputElement = document.querySelector("input");
    if (inputElement) {
      inputElement.addEventListener("keydown", handleKeyDown);
      return () => {
        inputElement.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [query]);

  return (
    <React.Fragment>
      <div style={{ position: "relative" }}>
      <span className="p-input-icon-left">
        {loading ? (
          <i className="pi pi-spin pi-spinner" />
        ) : (
          <i className="pi pi-search" />
        )}
        <InputText
          value={query}
          placeholder={t('SEARCH_BY_PATIENT_NAME')}
          onChange={handleChange}
        />
        </span>
        {query && (
          <i
            className="pi pi-times"
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer"
            }}
            onClick={handleClear}
          />
        )}
      </div>
      <>
      <Dialog
        header={t("PATIENTS")}
        style={{ width: "30vw",height:"20vh" }}
        visible={noPatientsDialogVisible}
        onHide={() => {setNoPatientsDialogVisible(false)}}
      ><p style={{ fontSize: "30px", color: "#75bef8" ,textAlign:"center"}}>{t("NO_PATIENTS_FOUND")}.</p>      
      </Dialog>
      </>
      <Dialog
        header={t("PATIENTS")}
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!visible) return;
          setVisible(false);
        }}
      >
        {(results || []).map((data, index) => (
          <PatientCard
            key={index}
            number={data.mrn}
            name={data.personnel_name}
            gender={data.personnel_gender}
            patient_type={data.patient_type}
            setVisible={setVisible}
            setQuery={setQuery}
          />
        ))}
      </Dialog>
    </React.Fragment>
  );
};

export default React.memo(Search);
